import {GetLoadables} from './loader'

// #if process.env.UIX_CHUNKED === 'true'
let loader = () => {
  return import(/* webpackChunkName: 'swiper' */ './swiperLoad')
}
const L = GetLoadables(loader, ['Swiper'])
// #endif

// #if process.env.UIX_CHUNKED === 'false'
// import * as L from './swiperLoad'
// #endif

export let {Swiper} = L
